import {
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import type { AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from "./azureAuthConfig";
import { useState, useEffect } from "react";
import type {ReactNode} from "react";
import { MsalProvider } from "@azure/msal-react";

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [msalInstance] = useState(() => new PublicClientApplication(msalConfig));
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
                
        await msalInstance.handleRedirectPromise();
        
        // Default to using the first account if no account is active on page load
        if (
          !msalInstance.getActiveAccount() &&
          msalInstance.getAllAccounts().length > 0
        ) {
          msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        }

        // Listen for sign-in event and set active account
        msalInstance.addEventCallback((event) => {
          const authenticationResult = event.payload as AuthenticationResult;
          const account = authenticationResult?.account;
          if (event.eventType === EventType.LOGIN_SUCCESS && account) {
            msalInstance.setActiveAccount(account);
          }
        });

        setIsInitialized(true);
      } catch (error) {
        console.error("MSAL initialization failed:", error);
      }
    };

    initializeMsal();
  }, [msalInstance]);

  if (!isInitialized) {
    return <div>Initializing authentication...</div>;
  }
  
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export function useAuthProvider() {
  return { AuthProvider };
}
